module.exports = __webpack_public_path__ + "static/media/post_insta_01.a1d6457f.mp4";